export default function debounce(func, time) {
    let timeout;
    return (...args) => {
        const executeFunction = () => {
            timeout = null;
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(executeFunction, time);
    };
};



// WEBPACK FOOTER //
// ./src/utils/debounce.js